import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import FiltroChaveValor from '../comum/FiltroChaveValor';
import adicionarFiltroEmpresa from '../../actions/empresa/adicionarFiltroEmpresa';
import removerFiltroEmpresa from '../../actions/empresa/removerFiltroEmpresa';
import listarFiltrosEmpresas from '../../actions/empresa/listarFiltrosEmpresas';
import {
  FILTRO_CONFIGURACAO_BPE,
  FILTRO_DATA_CRIACAO,
  FILTRO_EMAIL,
  FILTRO_EMPRESAS,
  FILTRO_ID_EMPRESA,
  FILTRO_NOME_FANTASIA,
  FILTRO_GRUPO,
  FILTRO_UF_BPE,
  FILTRO_HABILITADO_VENDER_SITE
} from '../../util/filtros';
import FiltroBuscaEmpresa from './FiltroBuscaEmpresa';
import {estados} from '../../util/constantsUtil';

export class FiltroEmpresas extends Component {
    
    componentDidMount() {
        this.props.listarFiltrosEmpresas()     
        
    }

    adicionarFiltro(filtro) {
        this.props.adicionarFiltroEmpresa(filtro)
    }

    removerFiltro(filtro) {
        this.props.removerFiltroEmpresa(filtro)
    }

    render() {
        if (!this.props.empresas) {
            return <div>Carregando...</div>
        }

        return (
            <React.Fragment>
                <div className="conteudo">
                    <FiltroBuscaEmpresa
                        filtro={FILTRO_ID_EMPRESA}
                        isNumero={true}
                    />
                    <FiltroBuscaEmpresa
                        filtro={FILTRO_DATA_CRIACAO}
                        opcoes={[new Date().getFullYear()]}
                        isFiltroData={true}
                    />
                    <FiltroBuscaEmpresa
                        filtro={FILTRO_NOME_FANTASIA}
                        opcoes={this.props.nomes}
                    />
                    <FiltroBuscaEmpresa
                        filtro={FILTRO_EMAIL}
                        opcoes={this.props.emails}
                    />
                    <FiltroChaveValor
                        filtro={FILTRO_EMPRESAS}
                        opcoes={this.props.empresas}
                        filtrosAdicionados={this.props.filtrosAdicionados}
                        adicionarFiltro={this.adicionarFiltro.bind(this)}
                        removerFiltro={this.removerFiltro.bind(this)}
                    />
                    <FiltroBuscaEmpresa
                        filtro={FILTRO_HABILITADO_VENDER_SITE}
                        opcoes={['Ativo', 'Inativo']}
                        isRadio={true}
                    />
                    <FiltroBuscaEmpresa
                        filtro={FILTRO_CONFIGURACAO_BPE}
                        opcoes={['Ativo', 'Inativo', 'Não Cadastrado']}
                        isRadio={true}
                    />
                    <FiltroChaveValor
                        filtro={FILTRO_UF_BPE}
                        opcoes={estados.map(elemento => ({chave: elemento.uf, valor: `${elemento.nome} - ${elemento.uf}`}))}
                        filtrosAdicionados={this.props.filtrosAdicionados}
                        adicionarFiltro={this.adicionarFiltro.bind(this)}
                        removerFiltro={this.removerFiltro.bind(this)}
                    />
                    <FiltroChaveValor
                        filtro={FILTRO_GRUPO}
                        opcoes={this.props.grupos}
                        filtrosAdicionados={this.props.filtrosAdicionados}
                        adicionarFiltro={this.adicionarFiltro.bind(this)}
                        removerFiltro={this.removerFiltro.bind(this)}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export const mapStateToProps = state => ({    
    empresas: state.filtrosEmpresas.empresas,
    nomes: state.filtrosEmpresas.nomes,
    emails: state.filtrosEmpresas.emails,
    filtrosAdicionados: state.filtrosAdicionadosEmpresas,
    grupos: state.filtrosEmpresas.grupo
});

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        adicionarFiltroEmpresa,
        removerFiltroEmpresa,
        listarFiltrosEmpresas
        
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(FiltroEmpresas)
